import { useState, useEffect } from 'react';
import { io } from 'socket.io-client';
import CHAT_EVENTS from '../constants/ChatEvents';
import { v4 as uuidv4 } from 'uuid';
import { useDispatch, useSelector } from 'react-redux';
import {
  addConversation,
  addMessage,
  finishConversation,
  joinGroupConversation,
  updateUserStatus,
} from 'src/redux/slices/chat';

const useWebsocket = () => {
  const [socket, setSocket] = useState(null);
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);

  useEffect(() => {
    const socket = io(`${import.meta.env.VITE_APP_CHAT_URL}`, {
      extraHeaders: {
        token: localStorage.getItem('token'),
        workspaceId: user.currentWorkspace,
        sessionId: uuidv4(),
      },
    });
    setSocket(socket);

    return () => socket.disconnect();
  }, []);

  return socket;
};

export default useWebsocket;
